import CarrierList from '../components/lists/CarrierList';
import { useCarriers } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminCarriersPage = ({ routes }) => {
  const { allCarriers } = useCarriers();

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      <CarrierList carriers={allCarriers} id="carriers" />
    </Layout>
  );
};

export default AdminCarriersPage;
